import { pickThemeColor, pickThemeFontStyles } from '@/theme';
import styled from 'styled-components';

export const StyledList = styled.div`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;

  img {
    object-fit: cover;
    object-position: center;
  }
`;

export const StyledListTitle = styled.p`
  margin-bottom: 0.5rem;
  color: ${pickThemeColor('BLACK')};
  ${pickThemeFontStyles('16', '24')};
`;
